// src/components/exam-builder/ItemRenderer.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import McqSingleRenderer from "../exam-player/renderers/McqSingleRenderer";
import ClozeRenderer from "../exam-player/renderers/ClozeRenderer";
import TrueFalseRenderer from "../exam-player/renderers/TrueFalseRenderer"; // ✅
import McqMultiRenderer from "../exam-player/renderers/McqMultiRenderer"; // ✅
import EssayRenderer from "../exam-player/renderers/EssayRenderer";
import SpeakingRenderer from "../exam-player/renderers/SpeakingRenderer";
import PassageMcqRenderer from "../exam-player/renderers/PassageMcqRenderer";
import OrderingWeightedRenderer from "../exam-player/renderers/OrderingWeightedRenderer";
import AudioGateRenderer from "../exam-player/renderers/AudioGateRenderer";
import SpeakingIntegratedRenderer from "../exam-player/renderers/SpeakingIntegratedRenderer";
import SentenceReconstructionRenderer from "../exam-player/renderers/SentenceReconstructionRenderer";
import CTestRenderer from "../exam-player/renderers/CTestRenderer";
import McqMatrixRenderer from "../exam-player/renderers/McqMatrixRenderer";
import MatchingRenderer from "../exam-player/renderers/MatchingRenderer";
import DragToGroupRenderer from "../exam-player/renderers/DragToGroupRenderer";
import ImageMatchingRenderer from "../exam-player/renderers/ImageMatchingRenderer";
import OrderingRenderer from "../exam-player/renderers/OrderingRenderer";
import ClozeRegexRenderer from "../exam-player/renderers/ClozeRegexRenderer";
import WordBankRenderer from "../exam-player/renderers/WordBankRenderer";
import ShortTextRenderer from "../exam-player/renderers/ShortTextRenderer";
import NumericRenderer from "../exam-player/renderers/NumericRenderer";
import DragDropItemTargetRenderer from "../exam-player/renderers/DragDropItemTargetRenderer";
import SentenceBuilderModal from "./SentenceBuilderModal";
import SentenceBuilderRenderer from "../exam-player/renderers/SentenceBuilderRenderer";
import SelectSentenceRenderer from "../exam-player/renderers/SelectSentenceRenderer";
import WritingPromptRenderer from "../exam-player/renderers/WritingPromptRenderer";
import FileUploadRenderer from "../exam-player/renderers/FileUploadRenderer";
import { X } from "lucide-react";

const itemTypeMap = {
  mcq_single: (props) => <McqSingleRenderer {...props} />,
  mcq_multi: (props) => <McqMultiRenderer {...props} />,
  mcq_matrix: (props) => <McqMatrixRenderer {...props} />,
  matching: (props) => <MatchingRenderer {...props} />,
  drag_to_group: (props) => <DragToGroupRenderer {...props} />,
  image_matching: (props) => <ImageMatchingRenderer {...props} />,
  ordering: (props) => <OrderingRenderer {...props} />,
  ordering_weighted: (props) => <OrderingWeightedRenderer {...props} />,
  cloze_text: (props) => <ClozeRenderer {...props} />,
  cloze_paragraph: (props) => <ClozeRenderer {...props} />,
  cloze_regex: (props) => <ClozeRegexRenderer {...props} />,
  word_bank: (props) => <WordBankRenderer {...props} />,
  short_text: (props) => <ShortTextRenderer {...props} />,
  essay: (props) => <EssayRenderer {...props} />, // 👈 اضافه شد
  numeric: (props) => <NumericRenderer {...props} />, // 👈 اضافه شد
  drag_drop_item_target: (props) => <DragDropItemTargetRenderer {...props} />,
  sentence_builder: (props) => <SentenceBuilderRenderer {...props} />,
  select_sentence: (props) => <SelectSentenceRenderer {...props} />,
  passage_mcq: (props) => <PassageMcqRenderer {...props} />, // 👈 اضافه شد
  audio_prompt: (props) => <SpeakingRenderer {...props} />,
  writing_prompt: (props) => <WritingPromptRenderer {...props} />,
  file_upload: (props) => <FileUploadRenderer {...props} />,
  true_false: (props) => <TrueFalseRenderer {...props} />,
  audio_gate: (props) => <AudioGateRenderer {...props} />,
  speaking_integrated: (props) => (
    <SpeakingIntegratedRenderer {...props} debug={true} />
  ),
  sentence_reconstruction: (props) => (
    <SentenceReconstructionRenderer {...props} />
  ),
  c_test: (props) => <CTestRenderer {...props} />,
};

export default function ItemRenderer({
  item,
  hideStem = false,
  onAnswerChange,
  initialAnswers,
  questionNumber,
  onContinue,
  // ✅ جدید
  practiceMode = false,
  onExplainAi, // () => void
  canUseAi,
  index
}) {
  const { t, i18n } = useTranslation();
  const [showExp, setShowExp] = useState(false);


  if (!item) return null;

  const RendererComponent = itemTypeMap[item.kind] || DefaultRenderer;

  const mustShowStem =
    item.kind === "true_false"
      ? true
      : item.kind === "mcq_single"
        ? false
        : item.kind === "mcq_multi"
          ? true
          : item.kind === "essay"
            ? true
            : item.kind === "audio_prompt"
              ? false
              : item.kind === "mcq_matrix"
                ? false
                : item.kind === "audio_gate"
                  ? false
                  : item.kind === "cloze_text"
                    ? true
                    : item.kind === "cloze_regex"
                      ? true
                      : item.kind === "c_test"
                        ? true
                        : item.kind === "sentence_reconstruction"
                          ? true
                          : hideStem;

  const canExplain = practiceMode; // اگر خواستی برای بعضی kind ها غیرفعال کن


  return (
    <div id={`item-${index + 1}`} className={hideStem ? "mb-5" : " bg-white p-5"}>
      {/* ✅ هدر ردیف: شماره سوال + دکمه AI */}
      {(questionNumber != null || canExplain) && (
        <div className="flex items-center justify-between mt-4">
          <div className="text-xs text-gray-500">
            {questionNumber != null
              ? `${t("preview.question")} ${questionNumber}`
              : ""}
          </div>

          {canExplain && (
            <div className="flex gap-1 items-center">
              <button
                onClick={onExplainAi}
                className=" px-5 py-1 rounded-lg border text-indigo-50 bg-indigo-700  disabled:opacity-50"
                type="button"
              >
                توضیح AI
              </button>
              {(item?.explanation?.fa || item?.explanation?.en) && (
                <button
                  onClick={() => setShowExp((p) => !p)}
                  className=" px-5 py-1 rounded-lg border text-indigo-50 bg-purple-500  disabled:opacity-50"
                  type="button"
                >
                  توضیح
                </button>
              )}
            </div>
          )}
        </div>
      )}

      {mustShowStem && (
        <div className="prose prose-sm max-w-none mb-3">
          <div
            dangerouslySetInnerHTML={{
              __html:
                (i18n.language === "fa" ? item?.stem?.fa : item?.stem?.en) ||
                t("preview.no_stem"),
            }}
          />
          {i18n.language === "fa" && item.body?.passage?.fa && (
            <div dangerouslySetInnerHTML={{ __html: item.body.passage.fa }} />
          )}
          {i18n.language === "en" && item.body?.passage?.en && (
            <div dangerouslySetInnerHTML={{ __html: item.body.passage.en }} />
          )}
        </div>
      )}

      <RendererComponent
        item={item}
        onAnswerChange={onAnswerChange}
        initialAnswers={initialAnswers}
        questionNumber={questionNumber}
        hideStem={hideStem}
        onContinue={onContinue}
      />

      <ExplanationModal
        isOpen={showExp}
        onClose={() => setShowExp(false)}
        html={item.explanation?.fa || item.explanation?.en}
        dir={item?.explanation?.fa ? "rtl" : "ltr"}
        title="توضیح پاسخ"
      />
    </div>
  );
}

function DefaultRenderer({ item }) {
  const { t } = useTranslation();
  return (
    <div className="text-sm text-gray-600">
      {t("preview.kind_not_supported", { kind: item.kind })}
    </div>
  );
}

function ExplanationModal({
  isOpen,
  onClose,
  html = "",
  title = "توضیح",
  dir = "rtl", // "rtl" | "ltr"
}) {
  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 z-40 flex items-center justify-center bg-black/40"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white w-full max-w-2xl rounded-2xl shadow-2xl p-5"
        dir={dir}
      >
        {/* header */}
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-800">{title}</h2>

          <button
            onClick={onClose}
            className="p-2 rounded-lg hover:bg-gray-100"
            aria-label="close"
          >
            <X />
          </button>
        </div>

        {/* content */}
        <div className="max-h-[60vh] overflow-auto border rounded-xl p-4 bg-indigo-50 prose prose-sm max-w-none">
          {html ? (
            <div dangerouslySetInnerHTML={{ __html: html }} />
          ) : (
            <div className="text-sm text-gray-500">توضیحی وجود ندارد.</div>
          )}
        </div>

        {/* footer */}
        <div className="flex justify-end mt-5">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700"
          >
            بستن
          </button>
        </div>
      </div>
    </div>
  );
}
